import { Form, FormItemProps, Input } from 'antd'
import { useEffect, useState } from 'react'
import { convertStringToLatLng } from '~/utils'
import Map from '~/components/Map'
import { GeocoderPin } from '~/components/Map/layers'
import { Rule } from 'antd/lib/form'
import { Box } from '@weareberyl/design-system'

type Location = {
  latitude: number
  longitude: number
}

interface Props {
  value?: string
  onChange?: () => void
  setLocation: React.Dispatch<React.SetStateAction<Location>>
}

const CoordinateInput = ({ value, onChange, setLocation }: Props) => {
  const { status } = Form.Item.useStatus()

  useEffect(() => {
    if (status === 'success') {
      const loc = convertStringToLatLng(value)
      if (loc) setLocation(loc)
    }
  }, [status])

  return (
    <Input
      value={value}
      onChange={onChange}
      placeholder="Coordinates (lat, long)"
    />
  )
}

const CoordinateInputFormItem = ({ rules, name, ...props }: FormItemProps) => {
  const [location, setLocation] = useState<Location | null>(null)
  const value = Form.useWatch(name)

  const layers: any[] = []
  if (location) {
    layers.push(GeocoderPin(location))
  }
  return (
    <Form.Item {...props}>
      <Form.Item
        name={name}
        rules={(
          [
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (
                  !value ||
                  Boolean(convertStringToLatLng(getFieldValue(name)))
                ) {
                  return Promise.resolve()
                }
                return Promise.reject(
                  new Error('Location must be of the format: lat, long'),
                )
              },
            }),
          ] as Rule[]
        ).concat(rules ?? [])}
        style={{ marginBottom: 0 }}
      >
        <CoordinateInput setLocation={setLocation} />
      </Form.Item>
      {value && location && (
        <Form.Item style={{ marginTop: 5, marginBottom: 0 }}>
          <Box height={200}>
            <div className="minimap-wrapper">
              <Map
                latitude={location?.latitude}
                longitude={location?.longitude}
                layers={layers}
                hideGeocoder
                disableController
              />
            </div>
          </Box>
        </Form.Item>
      )}
    </Form.Item>
  )
}

export default CoordinateInputFormItem
